import script from "./Image.vue?vue&type=script&lang=ts&setup=true"
export * from "./Image.vue?vue&type=script&lang=ts&setup=true"

import "./Image.vue?vue&type=style&index=0&id=191d0e83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-191d0e83"]])

export default __exports__